export default "__VITE_ASSET__DVg01VBP__"